/* Match catalogue words against names, types, tags and SKUs, excluding care-copy matches. */
(() => {
  const tokens = (value) => value.match(/[\p{L}\p{N}]+(?:[-/][\p{L}\p{N}]+)*/gu) || [];
  const descriptiveWords = new Set('cotton denim leather polyester wool acrylic nylon jersey fleece embroidery embroidered knitted woven oversized relaxed boxy regular heavyweight lightweight midweight long sleeve sleeves zip zipper drawcord applique appliqué crew neck hood hooded reversible straight leg raw rinse wash washed print printed graphic lining gsm patchwork t-shirt t-shirts tshirt tshirts tee tees shirt shirts hoodie hoodies jacket jackets jeans jean jogger joggers shorts sock socks beanie beanies cap caps hat hats black white red green blue navy grey gray yellow pink lemon orange gold indigo brown cream peony faded ink tinted dark light'.split(' '));
  const allowDescription = (value) => { const words = tokens(value).map(word => word.toLowerCase()); return words.length > 0 && words.every(word => descriptiveWords.has(word)); };
  const scopedQuery = (value) => {
    if (/[:"]/u.test(value)) return value; // Preserve deliberate Shopify search syntax.
    const words = tokens(value);
    const stopWords = new Set(['the', 'no']); // Shopify omits these from its title index.
    if (words.every(word => stopWords.has(word.toLowerCase()))) return value;
    return words.map(word => `(title:${word} OR product_type:${word} OR tag:${word} OR variants.sku:${word}${stopWords.has(word.toLowerCase()) ? ' OR title:*' : ''})`).join(' ');
  };
  window.waCatalogueSearch = { tokens, scopedQuery, allowDescription };
  // Keep old plain search links working, including searches shared before this repair.
  const url = new URL(window.location.href);
  if (document.body.dataset.waSearchPage === 'true' && url.searchParams.get('q')) {
    const query = url.searchParams.get('q');
    const results = document.querySelector('[data-wa-search-result-count]');
    if (query.startsWith('(title:') && results?.dataset.waSearchResultCount === '0') {
      // Descriptive searches such as "cotton" still use Shopify's full-text index.
      const original = document.querySelector('#Search-In-Template')?.value;
      const descriptiveSearch = allowDescription(original || '');
      if (descriptiveSearch && original !== query) {
        url.searchParams.set('q', original);
        url.searchParams.set('wa_fulltext', '1');
        window.location.replace(url.href);
        return;
      }
    }
    const scoped = scopedQuery(query);
    if (!url.searchParams.has('wa_fulltext') && scoped && scoped !== query) {
      url.searchParams.set('q', scoped);
      window.location.replace(url.href);
      return;
    }
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented || form.getAttribute('role') !== 'search') return;
    const input = form.querySelector('input[type="search"]');
    if (!input?.value.trim()) return;
    const query = scopedQuery(input.value.trim());
    if (!query || query === input.value.trim()) return;
    let hidden = form.querySelector('[data-wa-scoped-query]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.dataset.waScopedQuery = '';
      form.append(hidden);
    }
    hidden.name = 'q';
    hidden.value = query;
    input.removeAttribute('name'); // Keep the visible input and predictive query human-readable.
  });
})();
